import type { NextPage } from 'next'
import { Sustainability } from '@/client/modules/Sustainability'
import { SustainabilityProps } from '@/client/modules/Sustainability/types'
import { getCMSContent } from '@/client/utils'

const SustainabilityPage: NextPage<SustainabilityProps> = (data) => <Sustainability {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'SUSTAINABILITY')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default SustainabilityPage
